module.exports = __webpack_public_path__ + "static/media/Carbon Black.48c7ca7a.jpg";